seedWebApp.controller('DrawingsController', ['$scope', 'MaterialService',
    function ($scope, MaterialService) {

        $scope.prefs = {
            name: 'MaterialsGrid',
            sortByCol: null,
            canAdd: false,
            canEdit: true,
            canDelete: false
        };
        $scope.loadService = MaterialService.getDrawings;

        $scope.qtStockClass = function (item) {
            return 'qt-stocks';
        };

        $scope.materialTypeClass = function (item) {
            if (item == 'CADASTRAR') {
                return 'material-type-to-insert';
            }
        };

        $scope.columns = [
            { name: 'DrawingID', display: 'Código', customClass: function () { return 'agp-color'; }, filterOptions: [], width: 10, isKey: true },
            { name: 'DrawingName', display: 'Nome', filterOptions: [], limitTo: '35', width: 15 },
            { name: 'DrawingType', display: 'Tipo', filterOptions: [], limitTo: '35', width: 15, customClass: $scope.materialTypeClass },
            { name: 'DrawingFormat', display: 'Formato', filterOptions: [], limitTo: '35', width: 15 },
            { name: 'DrawingDistribution', display: 'Distr', filterOptions: [], width: 5 },
        ];

        $scope.insertNew = function () {
            MaterialService.openMaterialModal();
        }

        $scope.prefs.customEdit = function (item) {
            MaterialService.openMaterialModal(item.MaterialID);
        };

        $scope.loadColumns = MaterialService.getMaterialsColumns;
        
        $scope.resetService = MaterialService.resetCache;

        $scope.getTotal = function () {
            $scope.loadingTotal = true;
            MaterialService.getMaterialsCount().then(function (response) {
                $scope.loadingTotal = false;
                $scope.totalItems = response.data;
            });
        };

        $scope.getTotal();

        $scope.searchMode = function () {
            $scope.$broadcast('inputSearch', $scope.filterString);
        };

        $scope.doRefresh = function () {
            $scope.$broadcast('refreshServiceGrid');
        };

        $scope.toExcel = function () {
            $scope.$broadcast('toExcel', 'drawings');
        };

    }]);
